/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Usha        1310/02/2020      2573: API Error when selecting a facility
*********************************************************************************/
import { processClinicData } from "./clinic";
import moment from "moment/moment.js";
import differenceInCalendarYears from "date-fns/difference_in_calendar_years";
import {
  commonConstant,
  telemedicineVendors,
  careOptions,
} from "../../../server/triage/constants";
import i18next from "i18next";
import i18n from "./../../../i18n";
import {
  generateJsonWebToken,
  checkAndGetLocalStorageValue,
  checkAndGetSessionStorageValue,
  translateContent,
  getAndSetTranslateVal,
  checkAndChangeContent,
} from "../../../features/utils";

export async function getTriageEmergencyNumber({ country, state, actions }) {
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  await actions.sendTriageRequest({
    action: "getEmergencyNumber",
    data: {
      country,
      jwtAccessToken: jwtAccess_Token,
      accessToken: access_Token,
    },
  });
}
export function translation(str) {
  let n = str.todaysHours.indexOf(":");
  let timeInfo = str.todaysHours.slice(n);
  let weekday = str.todaysHours.substring(0, n);
  weekday = i18next.t(weekday);
  str.todaysHours = weekday.concat(timeInfo);
  str.todaysHours = str.todaysHours.replace(
    "Open 24 hours",
    i18next.t("findcareoption.Careoptions.OpeningHours")
  );
  return str;
}
export async function getTriageEmergencyResults({
  state,
  setState,
  actions,
  getState,
}) {
  //CHID-1  Start
  const {
    triageRequest: { sessionId, locationMeta, ageInYears, ageInDays },
  } = state;
  const encounterToken = localStorage.getItem("token");
  var moment = require("moment-timezone");
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  var translateArray = [
    {
      text: locationMeta.country,
    },
  ];
  var translatedContent = await translateContent(translateArray, "en");
  var listOfTranslatedArr = translatedContent.response.results;

  var tempCountry = await getAndSetTranslateVal(
    listOfTranslatedArr,
    0,
    locationMeta.country
  );
  // 5377 - after translation if we get USA change it to United States
  tempCountry = checkAndChangeContent(tempCountry, commonConstant.USA);
  var data =
    "?type=PhoneNumber&countryName=" +
    tempCountry +
    "&tagsBooleanOperator=and&tag=Country&secondTag=Medical Emergency";

  var command = "search/speciality" + data;
  if (!state.isFacility || !state.isTravelAid2) {
    var referenceResponse = await actions.getNodeCallBack(
      state,
      setState,
      actions,
      command
    );
  }
  var service =
    state.isFacility || (state.isTravelAid2 && !state.triageRequest.emergency)
      ? ""
      : "Emergency Room";

  data = {
    identifier: sessionId,
    Token: encounterToken,
    translate: false,
    languageTo: "",
    lat: locationMeta.latitude,
    latitude: locationMeta.latitude,
    longitude: locationMeta.longitude,
    city: locationMeta.city,
    province: locationMeta.province,
    country: tempCountry,
    service1: service,
    time: moment()
      .tz(locationMeta.country + "/" + locationMeta.city)
      .format(),
    radius: 40,
    unit: "Km",
    qty: 10,
    age: ageInYears,
    triageLevel: "",
    showGoogle: true,
    jwtAccessToken: jwtAccess_Token,
    accessToken: access_Token,
  };
  //CHID-1  End
  const success = await actions.sendTriageRequest({
    action: "getEmergencyResults",
    data,
  });

  var emergencyResult = false;
  if (success && success.message === commonConstant.success) {
    emergencyResult = true;
    var isPatientDetailsAdded = checkAndGetLocalStorageValue(
      "isPatientDetailsAdded"
    );
    var IsValidUser = checkAndGetSessionStorageValue("IsValidUser");
    if (isPatientDetailsAdded == "false" && !IsValidUser && !state.isFacility) {
      actions.updatePatientContact();
      localStorage.setItem("isPatientDetailsAdded", true);
    }
  }

  const {
    triageResponse: { emergencyServiceProviders = [] },
  } = getState();
  if (!state.isFacility || !state.isTravelAid2) {
    if (
      referenceResponse.response &&
      referenceResponse.response.results.length >= 1 &&
      referenceResponse.response.results[0].referenceValues.length > 0
    ) {
      if (referenceResponse.response.results[0].referenceValues.length > 1) {
        var emergencyNumbersArray = [];

        referenceResponse.response.results[0].referenceValues.map((item) => {
          emergencyNumbersArray.push(item.value);
        });

        state.triageResponse.emergencyNumber = emergencyNumbersArray;
      } else {
        state.triageResponse.emergencyNumber = [
          referenceResponse.response.results[0].referenceValues[0].value,
        ];
      }
    } else {
      state.triageResponse.emergencyNumber = [];
    }
  }
  if (
    !emergencyResult ||
    !emergencyServiceProviders ||
    !emergencyServiceProviders.length
  )
    return false;

  await actions.setTriageResponse({
    emergencySessionResults: processEmergencyServiceProviders({
      emergencyServiceProviders,
    }),
  });
}

export function processEmergencyServiceProviders({
  emergencyServiceProviders,
}) {
  const markers = [];
  const clinics = [];

  emergencyServiceProviders.forEach((location) => {
    const { latitude, longitude } = location;

    markers.push({
      lat: latitude,
      lng: longitude,
    });

    const processedData = processClinicData(location);
    let processedDataResult = translation(processedData);
    clinics.push(processedDataResult);
  });

  return { markers, clinics };
}

export async function AddingLocationToLog({
  state,
  actions,
  getState,
  clinic,
  history,
  AddLocationToLogCallback,
}) {
  const {
    triageRequest: { sessionId },
  } = state;
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  const data = {
    identifier: sessionId,
    token: localStorage.getItem("token"),
    facilityName: clinic.name,
    facilityAddress: clinic.line_1,
    facilityCity: clinic.city,
    facilityState: clinic.province,
    facilityCountry: clinic.country,
    FacilityEmail: clinic.email,
    FacilityPhone: clinic.phone,
    FacilityZip: clinic.zip,
    jwtAccessToken: jwtAccess_Token,
    accessToken: access_Token,
  };

  var response = await actions.sendTriageRequest({
    action: "ADDLocationToLog",
    data,
  });
  if (
    response &&
    response.message === commonConstant.success &&
    AddLocationToLogCallback != undefined
  ) {
    AddLocationToLogCallback(state, history, actions);
  }
}

export async function AddingFacilityContact({ state, actions, clinic }) {
  const {
    triageRequest: { sessionId },
  } = state;
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  const data = {
    GemTraigeLogId: state.triageResponse.data.GemTraigeLogId,
    Address: clinic.line_1,
    Name: clinic.name,
    ContactType: "",
    Fax: "",
    Phone: clinic.phone,
    Mobile: clinic.phone,
    Email: clinic.email,
    Comment: "",
    identifier: sessionId,
    token: localStorage.getItem("token"),
    jwtAccessToken: jwtAccess_Token,
    accessToken: access_Token,
  };

  await actions.sendTriageRequest({
    action: "AddFacilityContacts",
    data,
  });
}

export async function updateLogPharmaciesData({ state, actions, clinic }) {
  const { sessionId } = state.triageRequest;
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  var tempAddress = await translateAndGetAddress(
    state.triageRequest.location.parts.administrative_area_level_1,
    state.triageRequest.location.parts.country
  );

  await actions.sendTriageRequest({
    action: "getPharmacyDetails",
    data: {
      identifier: sessionId,
      token: localStorage.getItem("token"),
      name: clinic.name,
      phone: clinic.phone,
      mobile: clinic.phone,
      fax: clinic.fax,
      email: clinic.email,
      financeEmail: clinic.financeEmail,
      address: tempAddress,
      comment: "",
      isPatient: false,
      ExternalId:
        clinic.eazyscriptsPharmacyId != null ? clinic.eazyscriptsPharmacyId : 0,
      jwtAccessToken: jwtAccess_Token,
      accessToken: access_Token,
    },
  });
}

export async function updateLogTelemedCordination({ state, actions }) {
  const { sessionId } = state.triageRequest;
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  var vendorName;
  if (
    state.triageResponse.vendorsList.length > 1 &&
    state.triageResponse.vendorsList.filter(function (element) {
      return element.nameLocalization.localizations[0].value.includes(
        telemedicineVendors.MediOrbis
      );
    }).length > 0
  ) {
    vendorName = "MediOrbis";
  } else {
    vendorName =
      state.triageResponse.vendorsList[0].nameLocalization.localizations[0]
        .value;
  }
  var telemedType =
    state.isTravelAid2 &&
    checkAndGetLocalStorageValue("countryname") === "Canada"
      ? "2"
      : state.triageResponse.selectedConnectionType;
  await actions.sendTriageRequest({
    action: "getTelemedConnectionType",
    data: {
      identifier: sessionId,
      token: localStorage.getItem("token"),
      coordinationText: "",
      telemedicineType: telemedType,
      jwtAccessToken: jwtAccess_Token,
      accessToken: access_Token,
      vendor: vendorName,
    },
  });
}
export async function updateLogTelemedContactDetails({ state, actions }) {
  const { sessionId } = state.triageRequest;
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  var localRoom = "",
    mobileWithRoom = "";
  if (state.triageRequest.data.extensionOrRoomNumber) {
    localRoom = state.triageRequest.data.extensionOrRoomNumber;
  }
  var tempMob = await getAndSetValFromLocalStorage(
    checkAndGetLocalStorageValue("phonenumber"),
    state.triageRequest.data.mobile
  );

  var tempName = await getAndSetValFromLocalStorage(
    checkAndGetLocalStorageValue("username"),
    state.triageRequest.data.username
  );
  if (localRoom !== "") {
    mobileWithRoom = tempMob + "#" + localRoom;
  } else {
    mobileWithRoom = tempMob;
  }

  var tempAddress = await translateAndGetAddress(
    state.triageRequest.location.parts.administrative_area_level_1,
    state.triageRequest.location.parts.country
  );

  await actions.sendTriageRequest({
    action: "getTelemedConnectionDetails",
    data: {
      identifier: sessionId,
      token: localStorage.getItem("token"),
      name: tempName,
      phone: mobileWithRoom,
      mobile: mobileWithRoom,
      fax: "",
      email: state.triageRequest.data.email,
      financeEmail: "",
      address: tempAddress,
      comment: state.triageRequest.data.notes,
      isPatient: true,
      accepted: state.triageRequest.data.consent,
      extension: state.triageRequest.data.extensionOrRoomNumber,
      userContact: state.triageRequest.userContact,
      insuranceCarrier: state.triageRequest.data.insurance,
      policy: state.triageRequest.data.policyNum,
      travelDateEffectFrom: state.triageRequest.data.effectFrom,
      travelDateEffectTo: state.triageRequest.data.effectTo,
      primaryInsuredName: state.triageRequest.data.insuredOn,
      insuredBirthDate: state.triageRequest.InsuredBirthday,
      insuredGender: state.triageRequest.data.sex,
      insuredRelation: state.triageRequest.data.relation,
      jwtAccessToken: jwtAccess_Token,
      accessToken: access_Token,
    },
  });
}
export async function updatePatientContact({ state, actions }) {
  const { sessionId } = state.triageRequest;
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");

  var tempAddress = await translateAndGetAddress(
    (state.triageRequest.location && state.triageRequest.location.parts && state.triageRequest.location.parts.administrative_area_level_1) || "",
    state.triageRequest.location.parts.country
  );
  var localRoom = "",
    mobileWithRoom = "",
    comment = "";
  if (state.triageRequest.data != undefined) {
    if (state.triageRequest.data.extensionOrRoomNumber) {
      localRoom = state.triageRequest.data.extensionOrRoomNumber;
    } else {
      localRoom = state.triageRequest.data.roomnumber;
    }

    var tempMob = await getAndSetValFromLocalStorage(
      checkAndGetLocalStorageValue("phonenumber"),
      state.triageRequest.data.mobile
    );

    var tempName = await getAndSetValFromLocalStorage(
      checkAndGetLocalStorageValue("username"),
      state.triageRequest.data.username
    );

    if (localRoom !== "" && localRoom !== undefined) {
      mobileWithRoom = tempMob + "#" + localRoom;
    } else {
      mobileWithRoom = tempMob;
    }
    comment =
      state.triageRequest.data.notes || state.triageRequest.data.comments;
  }
  await actions.sendTriageRequest({
    action: "AddPatientDetails",
    data: {
      identifier: sessionId,
      token: localStorage.getItem("token"),
      name: tempName,
      Phone: mobileWithRoom,
      Mobile: mobileWithRoom,
      Fax: "",
      Email:
        localStorage.getItem("email") != "undefined"
          ? localStorage.getItem("email")
          : localStorage.getItem("userEmail"),
      DOB: state.triageRequest.dateofbirth,
      Address: tempAddress,
      Comment: comment,
      IsPatient: true,
      jwtAccessToken: jwtAccess_Token,
      accessToken: access_Token,
      extension: state.triageRequest.data ? state.triageRequest.data.extensionOrRoomNumber : undefined,
      userContact: state.triageRequest.userContact,
      insuranceCarrier: state.triageRequest.data ? state.triageRequest.data.insurance : undefined,
      policy: state.triageRequest.data ? state.triageRequest.data.policyNum : undefined,
      travelDateEffectFrom: state.triageRequest.effectFrom,
      travelDateEffectTo: state.triageRequest.effectTo,
      primaryInsuredName: state.triageRequest.data ? state.triageRequest.data.insuredOn : undefined,
      insuredBirthDate: state.triageRequest.InsuredBirthday,
      insuredGender: state.triageRequest.data ? state.triageRequest.data.sex : undefined,
      insuredRelation: state.triageRequest.data ? state.triageRequest.data.relation : undefined,
    },
  });
}

export async function updateVendorName({ state, actions }) {
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  var responseData = await actions.sendTriageRequest({
    action: "getVendorName",
    data: {
      jwtAccessToken: jwtAccess_Token,
      accessToken: access_Token,
      vendor: state.triageResponse.vendorsLocation.name,
      careOption: localStorage.getItem("careoption"),
    },
  });

  if (responseData && responseData.message === commonConstant.success) {
    actions.setTriageResponse({
      vendorsName: responseData.data,
    });
  }
}

export async function updateVendorLocation({ state, actions }) {
  const { sessionId, gender } = state.triageRequest;
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");

  var localRoom = "",
    mobileWithRoom = "",
    comment = "";
  if (state.triageRequest.data != undefined) {
    if (state.triageRequest.data.extensionOrRoomNumber) {
      localRoom = state.triageRequest.data.extensionOrRoomNumber;
    } else {
      localRoom = state.triageRequest.data.roomnumber;
    }

    var tempMob = await getAndSetValFromLocalStorage(
      checkAndGetLocalStorageValue("phonenumber"),
      state.triageRequest.data.mobile
    );

    if (localRoom !== "" && localRoom !== undefined) {
      mobileWithRoom = tempMob + "#" + localRoom;
    } else {
      mobileWithRoom = tempMob;
    }
    comment =
      state.triageRequest.data.notes || state.triageRequest.data.comments;
  }
  var responseData = await actions.sendTriageRequest({
    action: "getVendorLocation",
    data: {
      identifier: sessionId,
      token: localStorage.getItem("token"),
      jwtAccessToken: jwtAccess_Token,
      accessToken: access_Token,
    },
  });

  if (responseData && responseData.message === commonConstant.success) {
    actions.setTriageResponse({
      vendorsLocation: responseData.data,
    });
  }
}

export async function updateVendorContact({ state, actions }) {
  const { sessionId } = state.triageRequest;
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");

  if (state.triageRequest.selectedCareOptionName === careOptions.HouseVisit || state.triageRequest.selectedCareOptionName === careOptions.ConciergeCare) {
    var houseVisitData = {
      identifier: sessionId,
      token: localStorage.getItem("token"),
      jwtAccessToken: jwtAccess_Token,
      accessToken: access_Token,
      phone: state.triageResponse.vendorsLocation ? state.triageResponse.vendorsLocation.phone : undefined,
      address: state.triageResponse.vendorsName.country,
      name: state.triageResponse.vendorsLocation.name,
    };
    await actions.sendTriageRequest({
      action: "AddVendorContacts",
      data: houseVisitData,
    });
  } else {
    var objAddress =
      state.triageResponse.vendorsList[0].accessInformation
        .physicalAccessInformation.address;
    var lineAddress1 = objAddress.lineAddress1;
    var lineAddress2 = objAddress.lineAddress2;
    var city = objAddress.city;
    var province = objAddress.province;
    var country = objAddress.country;
    var postalCode = objAddress.postalCode;
    var address = [
      lineAddress1,
      lineAddress2,
      city,
      province,
      country,
      postalCode,
    ];

    var totalAddress = [];
    address
      .filter((card) => card !== "")
      .forEach((element) => {
        totalAddress.push(element);
      });

    var vendorName;
    if (
      state.triageResponse.vendorsList.length > 1 &&
      state.triageResponse.vendorsList.filter(function (element) {
        return element.nameLocalization.localizations[0].value.includes(
          telemedicineVendors.MediOrbis
        );
      }).length > 0
    ) {
      vendorName = "MediOrbis";
    } else {
      vendorName =
        state.triageResponse.vendorsList[0].nameLocalization.localizations[0]
          .value;
    }

    var telemedicineData = {
      identifier: sessionId,
      token: localStorage.getItem("token"),
      jwtAccessToken: jwtAccess_Token,
      accessToken: access_Token,
      phone: null,
      address: totalAddress.toString(),
      name: vendorName,
    };

    await actions.sendTriageRequest({
      action: "AddVendorContacts",
      data: telemedicineData,
    });
  }
}

export async function getEmergencyQuestions({ state, actions, setState }) {
  const { sessionId } = state.triageRequest;
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");
  const encounterToken = localStorage.getItem("token");
  let lang;
  let lantest = i18n.language;
  lang = actions.getEmergencyQuesLanguage(lantest);
  const data = {
    identifier: sessionId,
    Token: encounterToken,
    jwtAccessToken: jwtAccess_Token,
    accessToken: access_Token,
    languageId: lang,
  };
  window.store = store;
  var response = await actions.sendTriageRequest({
    action: "GetEmergencyQuestion",
    data,
  });
  if (response && response.message === commonConstant.success) {
    var symptomsInfo = response.symptomsInfo;
    setState({
      RelatedSymptomInfo: symptomsInfo,
    });
  }
  console.log("state.RelatedSymptomInfo", state.RelatedSymptomInfo);
}

export async function updatePatientContactForClinics({ state, actions }) {
  const { sessionId } = state.triageRequest;
  var jwtAccess_Token = generateJsonWebToken();
  var access_Token = checkAndGetSessionStorageValue("accessToken");

  if (state.triageRequest.data != undefined) {
    var tempName = await getAndSetValFromLocalStorage(
      checkAndGetLocalStorageValue("username"),
      state.triageRequest.data.username
    );

    var tempEmail = await getAndSetValFromLocalStorage(
      checkAndGetLocalStorageValue("userEmail"),
      state.triageRequest.data.email
    );

    var tempAddress = await translateAndGetAddress(
      state.triageRequest.location.parts.administrative_area_level_1,
      state.triageRequest.location.parts.country
    );
  }
  if (checkAndGetSessionStorageValue("IsValidUser") == "true") {
    await actions.sendTriageRequest({
      action: "AddPatientDetails",
      data: {
        identifier: sessionId,
        token: localStorage.getItem("token"),
        name: tempName,
        Phone: state.triageRequest.data.phone,
        Mobile: state.triageRequest.data.phone,
        Fax: "",
        Email: tempEmail,
        DOB: state.triageRequest.dateofbirth,
        Address: tempAddress,
        Comment: state.triageRequest.data.notes,
        IsPatient: true,
        jwtAccessToken: jwtAccess_Token,
        accessToken: access_Token,
        userContact: state.triageRequest.userContact,
        insuranceCarrier: state.triageRequest.data.insurance,
        policy: state.triageRequest.data.policyNum,
        travelDateEffectFrom: state.triageRequest.data.effectFrom,
        travelDateEffectTo: state.triageRequest.data.effectTo,
        primaryInsuredName: state.triageRequest.data.insuredOn,
        insuredBirthDate: state.triageRequest.InsuredBirthday,
        insuredGender: state.triageRequest.data.sex,
        insuredRelation: state.triageRequest.data.relation,
        childbirth: state.triageRequest.data.childbirth,
        pregnant: state.triageRequest.data.pregnant,
      },
    });
  } else {
    if (state.isTravelAid2) {
      var dob = moment(
        state.triageRequest.data.dateofbirth
      );
      var gender =
        state.isTravelAid2 &&
        checkAndGetLocalStorageValue("IsEmergencySelected") !== "true"
          ? state.triageRequest.data.gender
          : "U";
      var ageInYears = moment().diff(dob, "years");
      var email =
        localStorage.getItem("email") != undefined
          ? localStorage.getItem("email")
          : localStorage.getItem("userEmail");
      window.sessionStorage.setItem("dob", dob);
      await actions.sendTriageRequest({
        action:
          state.isTravelAid2 &&
          checkAndGetLocalStorageValue("IsEmergencySelected") !== "true"
            ? "UpdateMemberInformationTriageLog"
            : "UpdateTriageLogData",
        data: {
          identifier: sessionId,
          token: localStorage.getItem("token"),
          DOB: state.triageRequest.dateofbirth,
          Gender: gender,
          //pregnancyStatus: state.triageRequest.data.pregnant == true && gender == "F" ? 1 : 0,
          age: ageInYears,
          organization: localStorage.getItem("organization"),
          subOrganization: "Self Service",
          policyNumber: state.triageRequest.data.policyNum,
          accessToken: access_Token,
          jwtAccessToken: jwtAccess_Token,
          Height: state.triageRequest.data.Height,
          Weight: state.triageRequest.data.Weight
        },
      });
      // await actions.UpdateRiskFactors();
    }
    const data = state.isTravelAid2
      ? {
          identifier: sessionId,
          token: localStorage.getItem("token"),
          name: tempName,
          Phone: state.triageRequest.data.phone,
          Mobile: state.triageRequest.data.phone,
          Fax: "",
          Email: tempEmail,
          DOB: state.triageRequest.dateofbirth,
          Height: state.triageRequest.data.Height,
          Weight: state.triageRequest.data.Weight,
          Address: tempAddress,
          Comment: state.triageRequest.data.notes,
          IsPatient: true,
          jwtAccessToken: jwtAccess_Token,
          accessToken: access_Token,
          userContact: state.triageRequest.userContact,
          insuranceCarrier: state.triageRequest.data.insurance,
          policy: state.triageRequest.data.policyNum,
          travelDateEffectFrom: state.triageRequest.effectFrom,
          travelDateEffectTo: state.triageRequest.effectTo,
          primaryInsuredName: state.triageRequest.data.insuredOn,
          insuredBirthDate: state.triageRequest.InsuredBirthday,
          insuredGender: state.triageRequest.data.sex,
          insuredRelation: state.triageRequest.data.relation,
          childbirth: state.triageRequest.data.childbirth,
          pregnant: state.triageRequest.data.pregnant,
          organization: localStorage.getItem("organization"),
          subOrganization: "Self Service",
        }
      : {
          identifier: sessionId,
          token: localStorage.getItem("token"),
          name:
            state.IsValidUser && state.triageRequest.userName != undefined
              ? state.triageRequest.userName
              : localStorage.getItem("username"),
          Phone: "",
          Mobile: "",
          Fax: "",
          Email: state.IsValidUser
            ? checkAndGetSessionStorageValue("patientEmail")
            : checkAndGetLocalStorageValue("userEmail"),
          DOB: state.triageRequest.dateofbirth,
          Address:
            checkAndGetSessionStorageValue("state") +
            "," +
            checkAndGetSessionStorageValue("country"),
          Comment: "",
          IsPatient: true,
          jwtAccessToken: jwtAccess_Token,
          accessToken: access_Token,
        };
    await actions.sendTriageRequest({
      action: "AddPatientDetails",
      data: data,
    });
  }
}

async function translateAndGetAddress(area, country) {
  var translateArray = [
    {
      text: area,
    },
    {
      text: country,
    },
  ];
  var translatedContent = await translateContent(translateArray, "en");
  var listOfTranslatedArr = translatedContent.response.results;

  var tempAdminLevel = await getAndSetTranslateVal(
    listOfTranslatedArr,
    0,
    area
  );
  var tempCountry = await getAndSetTranslateVal(
    listOfTranslatedArr,
    1,
    country
  );
  tempCountry = checkAndChangeContent(tempCountry, commonConstant.USA);
  var localAdminLevel = "";
  var localCountry = "";

  if (tempAdminLevel) {
    localAdminLevel = tempAdminLevel + ",";
  }
  if (tempCountry) {
    localCountry = tempCountry;
  }

  var tempAddress = localAdminLevel + localCountry;
  return tempAddress;
}

async function getAndSetValFromLocalStorage(contentFromLocal, stateVal) {
  var tempVal = contentFromLocal;
  if (tempVal === "") {
    tempVal = stateVal;
  }
  return tempVal;
}
